import { initialsAvatarDataUrl } from "@compass/shared/utils/initialsAvatar";
import { Link } from "@tanstack/react-router";
import clsx from "clsx";
import { useState } from "react";

const deriveInitials = (name?: string | null): string => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    const first = parts[0]!.charAt(0).toUpperCase();
    const last = parts.length > 1 ? parts[parts.length - 1]!.charAt(0).toUpperCase() : "";
    return first + last;
};

type AvatarType = {
    userId?: number | undefined;
    photoUrl?: string | null;
    className?: string;
    name?: string | null;
    initials?: string;
    seed?: string | number;
};

export const SideAvatar = ({ userId, className, photoUrl, name, initials, seed }: AvatarType) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    const resolvedInitials = initials ?? deriveInitials(name);
    const fallbackSrc = initialsAvatarDataUrl({
        initials: resolvedInitials,
        seed: seed ?? userId ?? resolvedInitials,
    });

    const body = photoUrl ? (
        <>
            {imageLoaded ? (
                <img
                    className="h-auto w-full rounded-xl object-cover shadow-xl"
                    src={photoUrl}
                    alt={name ?? ""}
                    onError={() => setImageLoaded(false)}
                />
            ) : (
                <img
                    className="h-auto w-full rounded-xl object-cover shadow-xl"
                    src={fallbackSrc}
                    alt={resolvedInitials}
                />
            )}
            {/* Hidden image to detect loading */}
            <img
                src={photoUrl}
                alt=""
                style={{ display: "none" }}
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageLoaded(false)}
            />
        </>
    ) : (
        <img
            className="h-auto w-full rounded-xl object-cover shadow-xl"
            src={fallbackSrc}
            alt={resolvedInitials}
        />
    );

    if (userId) {
        return (
            <Link
                to="/profile/edit/$id"
                params={{ id: `${userId}` }}
                className={clsx("flex items-center justify-center ", className)}
            >
                {body}
            </Link>
        );
    }
    return <span className={clsx("flex items-center justify-center ", className)}>{body}</span>;
};
